import { FilterValue, Tooltip } from "../../components";
import FilterIconSvg from "../../assets/icons/svg/filter_list.svg?react";
import styles from "../../scss/media.module.scss";
import { handleFilterChangeUtil } from "@/components/Create/utils";
import { trackEvent, getTrackUserContext } from "@/utils/analytics";
import { getContentLocation } from "@/utils/utilFunctions/commmonFunctions";
import { store } from "@/store";

interface IFilterProps {
  filterKey: string | "clear";
  filterValue?: FilterValue;
  filters?: any;
  updateIsFilter?: any;
  updateIsClearFilter?: any;
  handleSetFilters?: any;
  toolTipText?: string;
  displayText?: FilterValue;
  dvk?: string;
  /** Display name for analytics (e.g. "Team", "Agency"). Defaults to capitalized filterKey. */
  filterDisplayName?: string;
  /** When true, fire content/Inline Filter/click event (for filter icons in MediaList table). */
  useContentEvent?: boolean;
}

type Props = IFilterProps;

const FilterButton = ({
  filterKey,
  filters,
  updateIsFilter,
  updateIsClearFilter,
  handleSetFilters,
  toolTipText,
  filterValue,
  displayText,
  dvk,
  filterDisplayName,
  useContentEvent = false,
}: Props) => {
  const location = getContentLocation();
  const filterName =
    filterDisplayName ??
    (typeof filterKey === "string"
      ? filterKey.charAt(0).toUpperCase() + filterKey.slice(1)
      : String(filterKey));

  return (
    <>
      <span
        onClick={() => {
          if (useContentEvent) {
            trackEvent("browse", {
              category: "content",
              entity: "Inline Filter",
              action: "click",
              location,
              ...getTrackUserContext(),
            });
          } else {
            trackEvent("browse", {
              category: "filters",
              entity: "AdvancedFilter",
              action: filterName,
              location,
              ...getTrackUserContext(),
            });
          }
          const updatefilters = handleFilterChangeUtil(
            filterKey || "",
            filterValue,
            displayText || "",
            filters,
            updateIsFilter,
            updateIsClearFilter,
            dvk
          );
          handleSetFilters(updatefilters);
        }}
        // className="position-absolute"
        // style={{ right: '-18px', top: '4px' }}
      >
        <Tooltip
          content={
            <p className="p-0 mb-0">{toolTipText || "Filter by this Filter"}</p>
          }
        >
          <FilterIconSvg className={`${styles["hover-icon"]} iconSvg`} />
        </Tooltip>
      </span>
    </>
  );
};

export default FilterButton;
